import {namespace} from 'vuex-class';
import {FINISH_LOADING, START_LOADING} from '@/store/mutationTypes';
import {Module} from 'vuex';
import {RootState} from '@/types';

export interface LoaderState {
  loading: number;
}

export const loaderModule = namespace('auth');

export default <Module<LoaderState, RootState>>{
  namespaced: true,
  state: <LoaderState>{
    loading: 0,
  },
  mutations: {
    [START_LOADING](state: LoaderState) {
      state.loading++;
    },
    [FINISH_LOADING](state: LoaderState) {
      state.loading--;
    },
  },
  actions: {
    start({commit}) {
      commit(START_LOADING);
    },
    finish({commit}) {
      commit(FINISH_LOADING);
    },
  },
  getters: {
    loading: (state: LoaderState) => state.loading > 0,
  },
};
